export default __webpack_public_path__ + "static/media/delivery-img.79a1e10d.png";